var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m39.4 896c0 43.3 35.4 78.8 78.8 78.8h834.9c17.7 0 31.5-13.8 31.5-31.5v-55.2c0-17.7-13.8-31.5-31.5-31.5h-766c-15.8 0-29.6-13.8-29.6-29.5v-746.4c0-17.7-13.7-31.5-31.5-31.5h-55.1c-17.7 0-31.5 13.8-31.5 31.5zm939.3-618.3c0-33.5-25.6-59.1-59.1-59.1-17.7 0-31.5 7.9-43.3 17.7l-169.3 169.4-116.2-110.3-2-1.9-3.9-4c-2 0-2-2-4-2-1.9-1.9-3.9-1.9-5.9-3.9-2 0-2-2-3.9-2-2 0-4-1.9-7.9-1.9-2 0-2 0-3.9-2-4 0-7.9-2-11.9-2-3.9 0-7.8 0-11.8 2-1.9 0-1.9 0-3.9 2-2 0-5.9 1.9-7.9 1.9-2 0-2 2-3.9 2-2 2-4 2-5.9 3.9-2 0-2 2-4 4-1.9 2-3.9 2-5.9 3.9l-224.5 226.5c-11.8 11.8-19.7 25.6-19.7 43.3 0 33.5 25.6 59.1 59.1 59.1 13.8 0 27.6-5.9 37.4-13.8l193-191 112.3 110.3c1.9 1.9 3.9 1.9 5.9 3.9l3.9 3.9c2 2 3.9 2 5.9 4 2 0 2 1.9 4 1.9 1.9 2 5.9 2 7.8 2 2 0 2 0 4 2 3.9 0 7.8 2 11.8 2 3.9 0 7.9 0 11.8-2h3.9c2 0 4-2 7.9-2 2 0 2-2 4-2 1.9 0 3.9-1.9 5.9-3.9 1.9 0 1.9-2 3.9-2l2-1.9 1.9-2 2-2 212.7-210.7c9.8-11.8 17.7-25.6 17.7-43.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.a1c82f02a8858d794837c0c59e7a3f5c.svg";
export { ForwardRef as ReactComponent };